import gsap from "gsap";

export default () => {
  const tl = gsap.timeline({ repeat: -1 });
  tl.from(".bottom-button", 0.5, { y: 0 }).to(".bottom-button", 1, { y: -30 });
};
